<nav
  class="navbar bg-primary navbar-expand-lg d-none d-lg-flex shadow px-3"
  [ngClass]="{
    'kids-navbar border-0': isKid
  }"
>
  <a
    [ngClass]="{
      'kids-logo': isKid
    }"
    class="navbar-brand py-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{ 'nav.home.page.screenreader' | translate : { fgbdefault: 'Move to home page' } }}"
  >
    <label id="homeLink" class="accessibility-only">Go To Home Page</label>
    <img
      alt=""
      [ngClass]="{
        'kids-logo': isKid
      }"
      class="ms-1 nav-logo"
      aria-labelledby="homeLink"
      [src]="(isClub1901 ? 'logos/logo-white.png' : 'logos/logo.svg') | contentAssetImage"
      draggable="false"
    />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="isCollapsed = !isCollapsed"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- Middle Club Links -->
  <div class="nav-middle w-100">
    <ng-container *inPopulation="[populations.Default, populations.Club1901]">
      <div class="navbar-collapse" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
        <div class="nav-container justify-content-center">
          <ul class="navbar-nav justify-content-center club-links" #greedyNav>
            <li class="nav-item">
              <a
                href="{{ 'nav.club.link.url' | translate }}"
                target="_blank"
                class="nav-link"
                attr.aria-label="{{ 'nav.rewards.screenreader' | translate : { fgbdefault: 'Move to rewards page' } }}"
                >{{ 'nav.club.link' | translate }}</a
              >
            </li>

            <li class="nav-item">
              <a
                href="{{ 'nav.tickets.link.url' | translate }}"
                target="_blank"
                class="nav-link"
                attr.aria-label="{{ 'nav.payment.screenreader' | translate : { fgbdefault: 'Move to challenges page' } }}"
                >{{ 'nav.tickets.link' | translate }}</a
              >
            </li>

            <li class="nav-item">
              <a
                href="{{ 'nav.shop.link.url' | translate }}"
                target="_blank"
                class="nav-link"
                attr.aria-label="{{ 'nav.payment.screenreader' | translate : { fgbdefault: 'Move to payment page' } }}"
                >{{ 'nav.shop.link' | translate }}</a
              >
            </li>
          </ul>
        </div>
      </div>

      <hr class="middle-line" />
    </ng-container>
    <div class="navbar-collapse kid" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
      <div class="nav-container" [ngClass]="{ 'kids-nav-container': isKid }">
        <ul class="navbar-nav" #greedyNav>
          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
            <ng-container *inPopulation="[populations.Default]">
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/brand']"
                  routerLinkActive="router-link-active"
                  attr.aria-label="{{ 'nav.offers.screenreader' | translate : { fgbdefault: 'Move to partner offer page' } }}"
                  >{{ 'nav.offers' | translate }}</a
                >
              </li>
            </ng-container>
            <ng-container *inPopulation="[populations.Club1901]">
              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/brand']"
                  routerLinkActive="router-link-active"
                  attr.aria-label="{{
                    'nav.1901.offers.screenreader' | translate : { fgbdefault: 'Move to affiliate scheme page' }
                  }}"
                  >{{ 'nav.1901.offers' | translate }}</a
                >
              </li>
            </ng-container>
          </ng-container>

          <!-- Default / Club1901: Rewards then Challenges -->
          <ng-container *inPopulation="[populations.Default, populations.Club1901]">
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/rewards']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.rewards.screenreader' | translate : { fgbdefault: 'Move to rewards page' } }}"
                >{{ 'nav.rewards' | translate }}</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/challenges']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.payment.screenreader' | translate : { fgbdefault: 'Move to challenges page' } }}"
                >{{ 'nav.challenges' | translate }}</a
              >
            </li>
          </ng-container>

          <!-- Kids: Challenges then Rewards -->
          <ng-container *inPopulation="[populations.Kids]">
            <li class="nav-item">
              <a
                class="nav-link text-white"
                [routerLink]="['/challenges']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.payment.screenreader' | translate : { fgbdefault: 'Move to challenges page' } }}"
                >{{ 'nav.challenges' | translate }}</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link text-white"
                [routerLink]="['/rewards']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{ 'nav.rewards.screenreader' | translate : { fgbdefault: 'Move to rewards page' } }}"
                >{{ 'nav.rewards' | translate }}</a
              >
            </li>
          </ng-container>

          <li class="nav-item">
            <a
              [ngClass]="{
                'text-white': isKid
              }"
              class="nav-link"
              [routerLink]="['/games']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.games.screenreader' | translate : { fgbdefault: 'Move to games page' } }}"
              >{{ 'nav.games' | translate }}</a
            >
          </li>

          <li class="nav-item">
            <a
              [ngClass]="{
                'text-white': isKid
              }"
              class="nav-link"
              [routerLink]="['/tv']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.gallery.screenreader' | translate : { fgbdefault: 'Move to gallery page' } }}"
              >{{ 'nav.gallery' | translate }}</a
            >
          </li>

          <ng-container *inPopulation="populations.Kids">
            <li class="nav-item">
              <a
                class="nav-link text-white"
                [routerLink]="['/training-zone']"
                routerLinkActive="router-link-active"
                attr.aria-label="{{
                  'nav.training.zone.screenreader' | translate : { fgbdefault: 'Move to training-zone page' }
                }}"
                >{{ 'nav.training.zone' | translate }}</a
              >
            </li>
          </ng-container>
        </ul>
      </div>
      <!-- Right Side Content -->
      <div class="d-flex align-items-center flex-nowrap my-2 my-lg-0 right-side-nav">
        <!--Notifications-->
        <fgb-notification-button></fgb-notification-button>

        <!--Hamburger-->
        <button
          class="nav-link text-white btn d-flex align-items-center px-0 justify-content-end hamburger-btn"
          (click)="openOffcanvas(offcanvasContent)"
          attr.aria-label="{{ 'nav.account.dropdown.screenreader' | translate : { fgbdefault: 'Click for more account menu' } }}"
        >
          <span class="material-icons">menu</span>
        </button>
      </div>
    </div>
  </div>
</nav>

<!--Offcanvas Template-->
<ng-template #offcanvasContent let-offcanvas>
  <div class="offcanvas-body d-flex flex-column h-100 p-4">
    <!--Header-->
    <div class="d-flex align-items-center justify-content-between mb-4">
      <img class="offcanvas-logo" [src]="'logos/logo.svg' | contentAssetImage" alt="" draggable="false" />
      <button class="btn p-0" (click)="offcanvas.dismiss()" aria-label="Close">
        <span class="material-icons">close</span>
      </button>
    </div>

    <!--Member Card-->
    <div
      class="offcanvas-member-card rounded p-3 mb-4"
      [ngClass]="isClub1901 ? 'bg-club1901-secondary' : 'bg-primary'"
      *ngIf="memberDetails$ | async as memberDetails"
    >
      <div class="fw-bold text-white font-size-18" [ngClass]="isClub1901 ? 'club1901-font text-capitalize' : 'text-uppercase'">
        {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
      </div>
      <div class="text-white font-size-14" *ngIf="card$ | async as memberCard">
        {{ 'member.id' | translate }} {{ memberCard.ExternalRefNumber }}
      </div>
    </div>

    <!--Menu Items-->
    <div class="d-flex flex-column gap-4 flex-grow-1">
      <!--Latest-->
      <a
        *ngIf="!isKid"
        class="offcanvas-menu-item d-flex align-items-center gap-3 text-decoration-none"
        [routerLink]="['/tv']"
        (click)="offcanvas.dismiss()"
      >
        <span class="material-symbols-outlined text-black">animated_images</span>
        <span
          class="fw-bold text-black font-size-18"
          [ngClass]="isClub1901 ? 'club1901-font text-capitalize' : 'text-uppercase'"
          >{{ 'nav.gallery' | translate }}</span
        >
      </a>

      <!--MyRewards-->
      <a
        class="offcanvas-menu-item d-flex align-items-center gap-3 text-decoration-none"
        [routerLink]="['/rewards/wallet']"
        (click)="offcanvas.dismiss()"
      >
        <span class="material-icons text-black">account_balance_wallet</span>
        <span
          class="fw-bold text-black font-size-18"
          [ngClass]="isClub1901 ? 'club1901-font text-capitalize' : 'text-uppercase'"
          >{{ 'nav.wallet' | translate }}</span
        >
      </a>

      <!--Partner Offers-->
      <ng-container *inPopulation="[populations.Default]">
        <a
          *ngIf="!isKid"
          class="offcanvas-menu-item d-flex align-items-center gap-3 text-decoration-none"
          [routerLink]="['/brand']"
          (click)="offcanvas.dismiss()"
        >
          <span class="material-symbols-outlined text-black">percent_discount</span>
          <span class="fw-bold text-black font-size-18 text-uppercase">
            {{ 'nav.partner.offers' | translate }}
          </span>
        </a>
      </ng-container>
      <ng-container *inPopulation="[populations.Club1901]">
        <a
          *ngIf="!isKid"
          class="offcanvas-menu-item d-flex align-items-center gap-3 text-decoration-none"
          [routerLink]="['/brand']"
          (click)="offcanvas.dismiss()"
        >
          <span class="material-symbols-outlined text-black">percent_discount</span>
          <span class="fw-bold text-black font-size-18 club1901-font text-capitalize">
            {{ 'nav.partner.1901.offers' | translate }}
          </span>
        </a>
      </ng-container>

      <!--Help-->
      <div>
        <button
          class="offcanvas-menu-item d-flex align-items-center justify-content-between w-100 btn p-0"
          (click)="helpExpanded = !helpExpanded"
        >
          <div class="d-flex align-items-center gap-3">
            <span class="material-icons text-black">info</span>
            <span
              class="fw-bold text-black font-size-18"
              [ngClass]="isClub1901 ? 'club1901-font text-capitalize' : 'text-uppercase'"
              >{{ 'nav.help' | translate }}</span
            >
          </div>
          <span class="material-icons text-black">{{ helpExpanded ? 'expand_less' : 'expand_more' }}</span>
        </button>
        <div *ngIf="helpExpanded" class="d-flex flex-column help-menu gap-3 pt-3">
          <a
            class="fw-bold text-black text-decoration-none font-size-14"
            href="{{ 'nav.terms.url' | translate }}"
            target="_blank"
            >{{ 'nav.terms' | translate }}</a
          >
          <a
            class="fw-bold text-black text-decoration-none font-size-14"
            href="{{ 'nav.faqs.url' | translate }}"
            target="_blank"
            >{{ 'nav.faq' | translate }}</a
          >
        </div>
      </div>
    </div>

    <!--Log Out-->
    <button
      class="offcanvas-logout-btn d-flex align-items-center justify-content-center gap-2 w-100 mt-4"
      (click)="logout(); offcanvas.dismiss()"
    >
      <span class="material-icons text-danger">logout</span>
      <span class="fw-bold text-danger font-size-14">{{ 'nav.log.out' | translate : { fgbdefault: 'Log out' } }}</span>
    </button>
  </div>
</ng-template>
